<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <TabsWidget activeTab="subcription" @selected="switchTab"></TabsWidget>
      <div class="tab-options"></div>
    </div>
    <div class="wrapper-body">
      <div class="balance-widget">
        <widgetCounter title="TOTAL SUBCRIBERS" :value="total_subscribers">
          <img src="@/assets/images/dashboard/Graph-1.svg" />
        </widgetCounter>
        <widgetCounter title="ACTIVE SUBCRIPTIONS" :value="active_subscriptions">
          <img src="@/assets/images/dashboard/Graph-2.svg" />
        </widgetCounter>
        <widgetCounter title="SUBCRIPTIONS BALANCE" :value="$formatMoney(
          subcription_balance,
          (decimalCount = 0),
          (decimal = '.'),
          (thousands = ',')
        )
          ">
          <img src="@/assets/images/dashboard/Graph-3.svg" />
        </widgetCounter>
      </div>
      <BalancePaymentType :cardAmount="payed_by_card" :momoAmount="payed_by_momo" :spennAmount="payed_by_spenn">
      </BalancePaymentType>
      <div class="income-widget">
        <div class="income-widget-header">
          {{ moment().format("YYYY") }}: SUBSCRIPTIONS REPORT
        </div>
        <div class="income-widget-body">
          <apexchart type="bar" height="100%" width="100%" :options="chartOptions" :series="series" ref="incomeChart">
          </apexchart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TabsWidget from "./components/TabsWidget.vue";
import BalancePaymentType from "./components/BalancePaymentType.vue";
export default {
  components: {
    TabsWidget,
    BalancePaymentType
  },
  sockets: {},
  data: () => ({
    loading_financial_data: false,
    series: [
      {
        name: "Income",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
    ],
    chartOptions: {
      colors: ["#1a191b"],
      chart: {
        type: "bar",
        height: 350,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
      },
      yaxis: {
        title: {
          text: "RWF",
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return "FWR " + val;
          },
        },
      },
    },
    total_subscribers: 0,
    active_subscriptions: 0,
    subcription_balance: 0,
    payed_by_card: 0,
    payed_by_momo: 0,
    payed_by_spenn: 0
  }),
  watch: {},
  mounted() {
    let vm = this;
    vm.getSubscriptionReport();
  },
  methods: {
    getSubscriptionReport() {
      let vm = this;
      vm.loading_data = true;
      vm.$store
        .dispatch("ADMIN_USER_GET_SUBSCRIPTION_REPORT")
        .then((response) => {
          vm.loading_data = false;
          vm.total_subscribers = response.data.return.total_subscribers;
          vm.active_subscriptions = response.data.return.active_subscriptions;
          vm.subcription_balance =
            response.data.return.available_subscription_balance;
          vm.$refs.incomeChart.updateSeries(
            [
              {
                data: response.data.return.subscription_income_in_year.map(item => parseInt(item)),
              },
            ],
            false,
            true
          );
          vm.payed_by_card = response.data.return.payed_by_card;
          vm.payed_by_momo = response.data.return.payed_by_momo;
          vm.payed_by_spenn = response.data.return.payed_by_spenn;
        })
        .catch(({ response }) => {
          vm.loading_data = false;
        });
    },
    switchTab(type) {
      let vm = this;
      vm.$emit("tab", type);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./styles/mobile-panel.scss";

.wrapper {
  padding: 0px;
  display: flex;
  flex-direction: column;
  height: 100%;
  @include dashboard-overview-mobile;

  .wrapper-header {
    width: 100%;
    height: 60px;
    padding: 0 10px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
    overflow-x: auto;

    .tabs-widget {
      display: flex;
      align-items: flex-end;

      .h-spacer {
        margin-right: 20px;
      }

      .tab-item {
        cursor: pointer;
        padding: 14px 4px;
        white-space: nowrap;

        &.active {
          color: var(--wecodefy-secondary-color, #9fc953);
          border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
        }
      }
    }

    .tab-options {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px 10px;

      .h-spacer {
        margin-right: 10px;
      }
    }
  }

  .wrapper-body {
    height: calc(100% - 60px);
    display: flex;
    flex-direction: column;

    @media (max-width: 650px) {
      overflow-y: auto;
    }

    .balance-widget {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 10px;
      padding: 10px;
      width: 100%;
      height: 160px;

      @media (max-width: 1180px) {
        grid-template-columns: repeat(2, 1fr);
      }

      @media (max-width: 650px) {
        height: unset;
      }

      @media (max-width: 596px) {
        grid-template-columns: repeat(1, 1fr);
      }
    }



    .income-widget {
      display: flex;
      height: calc(100% - 260px);
      width: 100%;
      flex-direction: column;
      margin: 0 !important;

      @media (max-width: 650px) {
        height: unset;
      }

      .income-widget-header {
        font-size: 20px;
        padding: 0px 20px;
        height: 60px;
        margin: 10px 0;
        display: flex;
        align-items: center;
      }

      .income-widget-body {
        padding: 0px 20px;
        height: calc(100% - 60px);
        display: flex;
        flex-direction: column;
        padding-bottom: 20px;
      }
    }
  }
}
</style>
